"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedProject = exports.CurrentVektorioProject = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var LinkedFolders_1 = require("./components/LinkedFolders");
var LinkFolders_1 = require("./components/LinkFolders");
var dispatchers_1 = require("./utils/dispatchers");
exports.CurrentVektorioProject = React.createContext({});
var LinkedProject = function (props) {
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    var linkFolderIcon = React.createElement(sok_ui_1.Icon, { className: 'fa-folder-upload' });
    var fetchProjects = function () {
        return dispatchers.fetchLinkedFolders({
            project: props.currentProject,
            vektorio: props.vektorioProject
        });
    };
    var unmount = function () {
        dispatchers.clear();
    };
    var mount = function () {
        fetchProjects();
        return unmount;
    };
    React.useEffect(mount, []);
    return (React.createElement(exports.CurrentVektorioProject.Provider, { value: props.vektorioProject },
        React.createElement("div", { className: 'tools' },
            React.createElement(sok_ui_1.Button, { color: 'green', size: 'medium', iconRight: linkFolderIcon, onClick: dispatchers.toggleSideMenu, text: (0, translation_1.getLocalization)("vektorio/linkFolders/link") })),
        React.createElement(LinkedFolders_1.LinkedFolders, { fetch: fetchProjects }),
        React.createElement(LinkFolders_1.LinkFolders, { currentProject: props.currentProject, vektorioProject: props.vektorioProject, onClose: dispatchers.toggleSideMenu })));
};
exports.LinkedProject = LinkedProject;
